<template> 
<div class="loader"></div>
</template>

<script>
 
export default {
  data() {
    return {
   
    };
  },
 
  props: {

  },
  watch: {

  },
  created: function () {

  },
};
</script>

<style>
  .loader {
  border: 8px solid #cccbcb; /* Light grey */
  border-top: 8px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 70px;
  height: 70px;
  animation: spin 1s linear infinite;
  position: absolute;
  left: 50%;
  top: 50%;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
